import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export default function InsForm3MT() {
    return (
        <React.Fragment>
            <Typography sx={{ pt: 3, fontSize: '2rem', }}>2　説明・確認事項</Typography>
            <Grid container direction='row' sx={{ pt: 1.5, pb: 1.5, pl: 5, alignItem: "center" }} >
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>1 ヒュースドクトル50</Typography>
                <Grid container direction='column' sx={{ pt: 1, pb: 1.5, pl: 3, }} >
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>1) 点検、検診システム</Typography>
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>2) 保証の内容</Typography>
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>3) 各種サービスの内容</Typography>
                    <Typography sx={{ pl: 2, pb: 1.5, fontSize: '1.5rem', }}>4) 今後のスケジュールについて</Typography>
                </Grid>
            </Grid>
            <Grid container direction='row' sx={{ pt: 1.5, pb: 1.5, pl: 5, alignItem: "center" }} >
                <Typography sx={{ pr: 2, fontSize: '1.7rem', }}>2 各種取り扱い方法</Typography>
                <Grid container direction='column' sx={{ pt: 1, pb: 1.5, pl: 3, }} >
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>1) 外部建具のメンテナンス：玄関ドア、窓、各種ドア(シャッター)</Typography>
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>2) フローリングのお手入れ</Typography>
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>3) 網戸のお手入れ</Typography>
                    <Typography sx={{ pl: 2, pb: 1, fontSize: '1.5rem', }}>4) 24時間換気システムのお手入れ及び、メンテナンス(定期交換部品)</Typography>
                    <Typography sx={{ pl: 5.5, pb: 3, fontSize: '1.5rem', }}>鍋物等を行う場合の換気方法、注意点(特にエアコンのスライム)の説明</Typography>
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>5) トイレ、洗面、キッチン換気扇のお手入れ</Typography>
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>6) 排水トラップ(浴室、洗濯機等)のお手入れ</Typography>
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>7) 外部木部のメンテナンスについて(今後のお手入れスケジュール)</Typography>
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>8) 「住まいの手びき」確認</Typography>
                    <Typography sx={{ pl: 2, pb: 3, fontSize: '1.5rem', }}>9) 準防火地域において"防火ダンパー付外部給排気口"設置の場合、ヒューズ切れの定期的な点検について</Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
